<template>
  <div :class="containerClass" :style="containerStyle">
    <div :class="bodyClass">
      <div class="mb-4"><img src="../../assets/logo-lecard.png" alt="Logo LeCard" style="width: 32px;"></div>
      <div v-if="step === 3">
        <auth2 @voltar="voltar" @auth="logar" :telefone="telefone" :error="error" :load="load"/>
      </div>
      <div v-else>
        <h5 class="mb-1">{{ title }}</h5>
        <div class="mb-3">
          <div class="mb-0" v-if="step === 1">{{ subtitle }}</div>
          <div class="mb-0" v-else>{{ dados.email }} <a href="javascript:" class="small text-primary" @click="voltar">(Alterar)</a></div>
        </div>
        <form @submit.prevent="logar()">
          <div class="form-group" v-if="step === 1">
            <input type="email" id="usuario" v-model="dados.email" class="form-control" :placeholder="emailPlaceholder" minlength="4" :disabled="load" required>
          </div>
          <div class="form-group input-senha" v-else>
            <input :type="showPassword ? 'text' : 'password'" id="inputSenha" class="form-control" v-model="dados.senha" :placeholder="passwordPlaceholder" autocomplete="password" :disabled="load" required>
            <i class="fa" :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" @click="mostrarSenha()" v-show="dados.senha.length > 0"
               :title="showPassword ? 'Esconder senha' : 'Mostrar senha'"></i>
          </div>
          <div class="alert-error small" v-if="error">{{ error }}</div>
          <button class="btn btn-primary btn-block py-2" :disabled="load">{{ load ? 'Aguarde' : submitLabel }}</button>
          <div class="text-center mt-4 mb-3">
            <p class="mb-0" v-if="step === 1 && showUnknownUserLink"><a class="text-primary" href="https://lecard.tawk.help/article/como-encontrar-meu-usuario" target="_blank">Não sei meu usuário</a></p>
            <a href="javascript:" class="text-primary text-decoration-none" @click="recuperarSenha()" v-else-if="showRecoverLink">Esqueceu a senha?</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Auth2 from "@/components/commons/Auth2";

export default {
  name: 'AuthLoginForm',
  components: {Auth2},
  props: {
    title: {
      type: String,
      default: 'Login'
    },
    subtitle: {
      type: String,
      default: 'Informe seu usuário de acesso'
    },
    submitLabel: {
      type: String,
      default: 'Continuar'
    },
    emailPlaceholder: {
      type: String,
      default: 'Usuário ou email'
    },
    passwordPlaceholder: {
      type: String,
      default: 'Digite sua senha'
    },
    initialEmail: {
      type: String,
      default: ''
    },
    showUnknownUserLink: {
      type: Boolean,
      default: true
    },
    showRecoverLink: {
      type: Boolean,
      default: true
    },
    allowRecoveryRedirect: {
      type: Boolean,
      default: true
    },
    canSubmit: {
      type: Boolean,
      default: true
    },
    blockedMessage: {
      type: String,
      default: ''
    },
    cardStyle: {
      type: String,
      default: 'max-width: 360px'
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      load: false,
      showPassword: false,
      step: 1,
      telefone: '',
      error: '',
      dados: {
        pin: '',
        email: this.initialEmail,
        senha: ''
      }
    }
  },

  methods: {
    logar(pin) {
      if (this.load) {
        return;
      }

      if (!this.canSubmit) {
        this.$swal(this.blockedMessage || 'Ação indisponível no momento.');
        return;
      }

      this.dados.pin = "";

      switch (this.step) {
        case 1:
          this.dados.senha = "";
          break;

        case 3:
          this.dados.pin = pin || "";
          break;
      }

      this.error = "";
      this.load = true;
      this.$http.post(this.base_server + 'auth/v2/login', this.dados)
        .then(res => {
          const data = res.data || {};

          if (!data.success || !['1','2'].includes(data.id_funcao)) {
            this.error = "Este usuário não tem acesso nesta plataforma!";
            this.load = false;
            return;
          }

          if (data.token) {
            this.load = false;
            this.$emit('authenticated', { data, email: this.dados.email });
            return;

          } else if (data.sem_senha) {
            this.load = false;

            if (this.allowRecoveryRedirect) {
              sessionStorage.setItem('sem_senha', this.dados.email);
              this.$router.push('/recuperar');
              return;
            }

            this.error = 'Este usuário ainda não possui senha. Faça o primeiro acesso pela tela principal.';
            return;
          }

          this.load = false;
          this.telefone = data.telefone;

          if (data.step === 2) {
            this.step = 3;

          } else if (this.step === 1) {
            this.step = 2;
            this.$nextTick(() => {
              this.$helpers.focusElement('inputSenha');
            });
          }

        }, res => {
          this.load = false;

          if (!res.status) {
            const msg = this.$helpers.verificarServerAlternativo(this.server_alternativo, true);
            this.$swal(msg);

          } else {
            const data = res.data || {};
            this.error = data.msg ? data.msg : 'Erro temporário';

            if (res.status === 401) {
              this.$helpers.focusElement(this.step === 3 ? 'validar_cod_pin' : (this.step === 1 ? 'usuario' : 'inputSenha'));
            }
          }
        });
    },

    voltar() {
      this.step = 1;
      this.dados.pin = "";
      this.error = "";
      this.$nextTick(() => {
        this.$helpers.focusElement('usuario');
      });
    },

    mostrarSenha() {
      this.showPassword = !this.showPassword;
    },

    recuperarSenha() {
      sessionStorage.setItem('recuperar', this.dados.email);
      this.$router.push('/recuperar');
    }
  },

  computed: {
    containerClass() {
      return this.embedded ? '' : 'card shadow-sm border mx-auto';
    },

    containerStyle() {
      return this.embedded ? '' : this.cardStyle;
    },

    bodyClass() {
      return this.embedded ? 'auth-form-body' : 'card-body';
    }
  },

  mounted() {
    if (this.initialEmail) {
      this.$helpers.focusElement('inputSenha');

    } else {
      this.$helpers.focusElement('usuario');
    }
  }
}
</script>

<style scoped>
.auth-form-body {
  padding: 4px 4px 0;
}
</style>
